import {
  Podcast,
  PodcastChangeRequest,
  PodcastValidationError,
} from "src/types/coaching/podcast";

import _ from "lodash";

export const preparePodcastRequest = (source: Podcast, target: Podcast) => {
  const changes = {} as PodcastChangeRequest;

  if (!_.isEqual(source.name, target.name) && target.name) {
    changes.name = target.name;
  }

  if (
    !_.isEqual(source.description, target.description) &&
    target.description
  ) {
    changes.description = target.description;
  }

  if (!_.isEqual(source.banner, target.banner)) {
    changes.thumbnail = { ...target.banner } as any;
    const sourceBackground = _.get(source, "banner.background.id");
    const targetBackground = _.get(target, "banner.background.id");

    if (sourceBackground !== targetBackground) {
      _.set(changes, "banner.background", targetBackground);
    } else {
      _.set(changes, "banner.background", null);
    }
  }

  const configChanges = preparePodcastConfigurationRequest(source, target);
  if (!_.isEmpty(configChanges)) {
    changes.assets = configChanges.assets;
    changes.voicePreset = configChanges.voicePreset;
    changes.duration = configChanges.duration;
  }

  const sourceSkills = (source.skills || []).map((item) => item.id);
  const targetSkills = (target.skills || []).map((item) => item.id);
  if (!_.isEqual(sourceSkills, targetSkills)) {
    changes.skills = targetSkills;
  }

  return changes;
};

//Validate Podcast Request
export const validatePodcastRequest = (podcast: Podcast) => {
  const errors: PodcastValidationError[] = [];

  if (!podcast.name) {
    errors.push({
      type: "podcast",
      uuid: podcast.id!,
      property: "name",
      message: "Podcast name is required",
      warning: false,
    });
  } else if (podcast.name.length > 1000) {
    errors.push({
      type: "podcast",
      uuid: podcast.id!,
      property: "name",
      message: "Podcast name cannot be more than 1000 characters",
      warning: false,
    });
  }

  if (!podcast.description) {
    errors.push({
      type: 'podcast',
      uuid: podcast.id!,
      property: 'description',
      message: 'Descriptions are optional but highly recommended for completeness.',
      warning: true
    });
  } else if (podcast.description.length > 1000) {
    errors.push({
      type: 'podcast',
      uuid: podcast.id!,
      property: 'description',
      message: 'Description cannot be more than 1000 characters',
      warning: false
    });
  }

  if (!podcast.skills || _.size(podcast.skills) == 0) {
    errors.push({
      type: "podcast",
      uuid: podcast.id!,
      property: "skills",
      message: "Enter skills relevant to this podcast",
      warning: false,
    });
  }

  if (!podcast.assets || _.size(podcast.assets) == 0) {
    errors.push({
      type: "podcast",
      uuid: podcast.id!,
      property: "assets",
      message: "Add atleast one or more asset to the podcast",
      warning: false,
    });
  }

  return errors;
};

export const preparePodcastConfigurationRequest = (source: Podcast, target: Podcast) => {
  const changes = {} as PodcastChangeRequest;
  const sourceAssets = (source.assets || []).map((asset) => {
    return asset.id;
  });
  const targetAssets = (target.assets || []).map((asset) => {
    return asset.id;
  });

  if (!_.isEqual(sourceAssets, targetAssets)) {
    changes.assets = targetAssets;
  }

  if (!_.isEqual(source.voicePreset?.id, target.voicePreset?.id)) {
    changes.voicePreset = target.voicePreset?.id;
  }

  if(!_.isEqual(source.duration, target.duration)) {
    changes.duration = target.duration;
  }

  return changes;
};

export const formatTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  const paddedMins = String(mins).padStart(2, "0");
  const paddedSecs = String(secs).padStart(2, "0");

  if (hrs === 0) {
    return `${paddedMins}:${paddedSecs}`;
  } else {
    const paddedHrs = String(hrs);
    return `${paddedHrs}:${paddedMins}:${paddedSecs}`;
  }
};